module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="pro-bottom-info">\r\n  <div class="mycontainer">\r\n    <div class="left wow fadeInLeft">有问题？我们随时提供帮助</div>\r\n    <div class="right wow fadeInRight">\r\n      <a href="questions.html?message=true"><i class="iconfont icon-zixunjilu1"></i>在线咨询</a>\r\n      <a href="questions.html?message=true"><i class="iconfont icon-renminbi"></i>获取报价</a>\r\n      <a href="contact.html"><i class="iconfont icon-dianhua"></i>联系我们</a>\r\n    </div>\r\n  </div>\r\n</section>';

}
return __p
}